export class SessionRefreshFailedError extends Error {
  constructor(public readonly reason: string) {
    super(`Session refresh failed: ${reason}`);
    this.name = "SessionRefreshFailedError";
  }
}

export class SessionExpiredError extends Error {
  constructor(message: string = "Session expired, redirecting to portal") {
    super(message);
    this.name = "SessionExpiredError";
  }
}
